<!--
  Braintree PayPal express button (PayPal Web SDK v6). V6 does not render its own button — the flow
  starts on this button's click (session.start() needs the user's gesture). Shown only once the SDK
  is ready; disabled while a checkout is in flight.
-->
<div class="braintree-paypal" *ngIf="ready">
  <button type="button" class="braintree-paypal__button" [disabled]="processing" (click)="onStartCheckout()">
    @if (processing) {
      <span>{{ 'paypal.processing' | translate: { fgbdefault: 'Processing…' } }}</span>
    } @else {
      <img src="{{ 'providers/35.svg' | contentAssetImage }}" alt="PayPal" class="braintree-paypal__logo" />
      <img src="{{ 'providers/paypal.svg' | contentAssetImage }}" alt="PayPal" class="paypal-logo" />
    }
  </button>
</div>
